import { IDirectoryEntity } from "@/ContactDirectory/Models/IDirectoryEntity";
import { DirectorySearchInfo } from "../Search/DirectorySearchInfo";
import { DirectorySearchTitle } from "../Search/DirectorySearchTitle";
import { FaxDirectorySearchResultItem } from "../Search/FaxDirectorySearchResultItem";

import styles from "./DuplicateItem.module.scss";

interface IDuplicateItemProps {
    /**
     * The item containing the directory entity to render
     */
    item: FaxDirectorySearchResultItem;

    /**
     * Is the current duplicate item selected.
     * @remark This is ignored if this component is not the main parent of the recursion.
     */
    isSelected?: boolean;

    /**
     * Callback function use to select a specific duplicate item.
     */
    onSelect?: () => void;

    /**
     * Indicates if the current component is a child of the DuplicateItem component.
     * Since we are rendering this component recursively, we have to apply different styles when the parent is a Duplicate Item.
     */
    isSubItem?: boolean;
}

/**
 * Render's the duplicate item of a contact directory entity
 */
function DuplicateItem(props: IDuplicateItemProps): JSX.Element {
    const entity = props.item.entity;
    const linkedEntities = entity.getLinkedDirectoryEntities();

    const className = `${styles.duplicateItem} ${props.isSelected && !props.isSubItem ? styles.selected : ""} ${props.isSubItem ? styles.subItem : ""}`;
    return (
        <li
            key={entity.id}
            className={className}
            onClick={() => props.onSelect?.()}
        >
            <DirectorySearchTitle
                searchResultItem={props.item}
                isSubItem={props.isSubItem}
            />
            <DirectorySearchInfo
                entity={entity}
                onSelectFaxNumber={() => props.onSelect?.()}
            />
            {linkedEntities.any() && (
                <ul>{linkedEntities
                    .map((linkedEntity: IDirectoryEntity) => (
                        <DuplicateItem
                            key={`${entity.id}_${linkedEntity.id}`}
                            item={new FaxDirectorySearchResultItem({ id: linkedEntity.id, entity: linkedEntity })}
                            isSubItem
                        />
                    ))}
                </ul>
            )}
        </li>
    );
}

export { DuplicateItem };
